export default {
  custom: {
    batchModify: '批量修改',
    importResumeanalysis: '导入简历解析',
    exportList: '导出列表',
    exportAllFields: '导出全部字段',
    webfromlink: 'WEB表单链接',
    transfer: '转移',
    receive: '领取',
    distribution: '分配',
    move: '移动',
    modify: '修改',
    returnToHighSeas: '退回公海池',
    returnToHighSeasSuccess: '已退回公海池',
    receiveSuccess: '领取成功',
    share: '共享',
    nextStep: '下一步',
    linkPublish: '链接发布',
    technicalSupport: '数字一体化管理平台',
    dataDetails: '数据详情',
    basicData: '基本资料',
    open: '打开',
    copy: '复制',
    openAccess: '公开访问',
    accessWithPwd: '凭密码访问',
    scanQRcodeForFriend: '扫二维码，分享给好友',
    SigninQRcode: '签到二维码',
    downloadQRcode: '下载二维码',
    extendedLinks: '扩展链接',
    multipleLinkMsg: '对同一个表单赋予多个链接地址，用于标识不同数据提交来源',
    copyToClipboard: '已复制至剪切板',
    signin: '签到',
    addSubmenu: '添加子菜单',
    checkShowFields: '勾选您要显示的字段',
    batchupdateMsg1: '数据批量修改后将不允许撤回，不支持对查重字段、选项字段控制-控制字段批量修改;',
    batchupdateMsg2:
      '不支持批量修改组件包含：附件、图片、简单公式、函数公式、高级公式、自动编号、关联关系、条码、定位、富文本;',
    fieldsToModify: '要修改的字段',
    modifiedValue: '修改的值为',
    modifiedValueNotEmpty: '修改的值不能为空',
    emailFormatError: '电子邮箱格式错误',
    phoneFormatError: '手机格式错误',
    enterInteget: '请输入整数',
    numComponentMaxlength9: '数字组件最大长度为9位数',
    decimalNumber: '小数位最多为',
    batchupdataSuccess: '批量修改完成',
    batchupdataLongMsg: '处理时间过长,您可以先去处理其他工作，系统会继续处理剩余数据.',
    selectMatchingRule: '请选择匹配规则',
    diyNeeds: '个性化需求',
    writeLetters: '写信',
    dynamic: '动态',
    transferPerson: '转移负责人',
    transformation: '转换',
    dataLink: '数据链接',
    matching: '匹配',
    datalinkNotopen: '未开启数据链接',
    automationTuijian: '自动化推荐',
    uploadPictures: '上传图片',
    addAttachments: '添加附件',
    useAppScan: '使用平台移动端扫描访问数据',
    noPermission: '无权进行此操作',
    name: '名称',
    screenConditions: '筛选条件',
    visibleMembers: '可见成员',
    submenuNameRequired: '子菜单名称必填',
    hideOlderDynamics: '隐藏较早动态',
    haveChecked: '已查看',
    noLook: '未查看',
    operator: '操作人',
    operationTime: '操作时间',
    comment: '沟通',
    lookState: '查看状态',
    unknownNameData: '未知名称的数据',
    batchImportResumeanalysis: '批量导入简历解析',
    selectResumeFile: '请选择需要导入的简历文件',
    clickUploadMulitpResumeFile: '点击可上传多份简历，每次最多上传10个,单个文件不得超过10MB',
    addFile: '添加文件',
    supportDoc: '支持doc、docx、pdf、html、JPG、BMP等格式',
    analyticalResults: '解析结果',
    analyticalComplete: '解析成功',
    analyticalFail: '解析失败,请检查网路是否正常',
    dataOutLink: '数据外链',
    dataInLink: '数据内链',
    onlyUseAppSaoyisao: '仅支持使用平台移动端扫一扫访问数据',
    dataSharingSettings: '指定的数据共享设置,可将部门或成员一起共享此数据',
    shareTo: '共享给',
    accessAuth: '访问权限',
    onlyReady: '只读',
    readyEdit: '读写',
    readyEditDelete: '读写删',
    modulePrintPdf: '模块详情页面打印（PDF格式）',
    printPreview: '打印预览',
    printSetting: '打印设置',
    downloadTemplate: '下载模版',
    importTemplate: '导入模版',
    complete: '完成',
    importData: '导入数据',
    updateData: '更新签到状态',
    pleaseImportData: '请按照数据模版的格式准备要导入的数据',
    mattersNeedingAttention: '注意事项',
    updateDataBeCareful1: '导入模板可自行进行创建，导入模板必须为xls格式',
    updateDataBeCareful2: '模板第一行为列表字段，需包含匹配字段名称和签到状态；名称必须一致',
    updateDataBeCareful3:
      '匹配字段最好选择无重复数据的字段，若导入更新时匹配到多条数据，以最新的数据作为更新内容',
    updateDataBeCareful4: '更新导入只能对已有数据进行更改',
    importDataBeCareful1: '模版中的表头名称不可更改，表头行不能删除',
    importDataBeCareful2: '导入格式为xlsx，最多只允许上传10000条，文件大小不超过20M',
    importDataBeCareful3:
      '单选类型：系统提供字段对应的单选值，用户只能选择，不能手动输入，否则会报错',
    importDataBeCareful4:
      '多选类型：字段备注提供该字段对应的选项值，用户需自行输入选项值，如果有多个选项值请使用英文","隔开',
    importDataBeCareful5: '日期/时间格式要求：2018-2-23、2018-8-23 12:00:00',
    importDataBeCareful6: '多级下拉：用户需自行输入多级下拉选项值，选项值用英文","隔开',
    importDataBeCareful7: '子表单：新sheet页面中显示子表单内容，通过子表单编号对应主表序号形成对应',
    clickDownloadTemplate: '点此下载数据导入模版',
    chooseTemplate: '选择需要导入的数据模版',
    dataTemplateMax10000:
      '数据模版中，表头字段名称需与系统保持一致，单次导入行数不得超过10000行，超出请分批导入',
    chooseMatchingData: '选择匹配数据后要更新的字段',
    chooseDataField: '选择数据的匹配字段',
    addComplete: '添加成功',
    importError1: '导入数据失败，请下载失败日志',
    importError2: '点此下载导入失败日志',
    importError3: '导入数据失败',
    chooseMatchField: '请选择数据的匹配字段',
    chooseUpdateloadTemplate: '请上传模版文件',
    startImport: '开始导入',
    return: '退回',
    moveTo: '移动至',
    moveComplete: '移动成功',
    closeAll: '关闭全部',
    closeOther: '关闭其他',
    refreshCurrentPage: '刷新当前页',
    Correlation: '关联关系',
    serialNumber: '序号',
    autoCreate: '自动生成',
    checkRepeat: '查重',
    checkInStatus: '签到状态',
    selectProvince: '选择省市区',
    unknown: '未知',
    saveAutoCreate: '保存后自动生成',
    saveAutoCompute: '保存后自动计算',
    national: '全国',
    uploadResume: '上传简历',
    oneFileMax10M: '单个文件不得超过10MB',
    supportDocDocx: '支持doc、docx、pdf、html、JPG、BMP等格式',
    analysisFailCheckNetwork: '解析失败，请检查网络是否正常',
    addRecords: '添加记录',
    uploadAvatar: '上传头像',
    gray: '灰度',
    blackWhite: '黑白',
    inverse: '反色',
    attPicNotFirst: '附件和图片不要放在第一位',
    subformNotFirst: '子表单不能放在第一位',
    zhangsan: '张三',
    proviewMode: '预览模式',
    transTargetModule: '可转换目标模块',
    noTransModule: '无转换模块',
    transSuccess: '转换成功',
    ifTransDataInfo: '将当前数据的负责人转移给其他负责人? 转移成功后，该操作将无法恢复',
    transShareMember: '转移后共享给当前数据负责人',
    personNotEmpty: '负责人不能为空',
    sharepersonNotEmpty: '共享人不能为空',
    fenpeiSuccess: '分配成功',
    selectReturnHighpool: '选择要退回的公海池',
    selectMoveHighpool: '选择要移动至的公海池',
    personnelCard: '个人名片',
    editModuleLayout: '模块设置',
    modifyIconName: '修改图标和名称',
    manageCockpit: '数据报表',
    total: '总计',
    determineDelReport: '确定要删除该数据分析吗?',
    realNameAuthMsg: '实名认证时 姓名/身份证号 不能为空',
    idCardBad: '身份证号格式不正确',
    verificationPassed: '校验通过',
    verificationFailed: '校验不通过',
    continueSaving: '继续保存',
    doNotSave: '不保存',
    sendEmail: '发送邮件',
    record: '条记录',
    showNotFilledField: '显示未填字段',
    hiddenNotFilledField: '隐藏未填字段',
    idCradPicture1: '人像面照片',
    idCradPicture2: '国徽面照片',
    // 新增：行驶证上传说明
    idCradPicture3: '行驶证图片',
    freezeThisColumn: '冻结此列',
    unfreezeThisColumn: '解冻此列',
    uploadOnly: '只允许上传',
    limitPerPicture: '每张图片限制',
    limitPerAttachment: '每个附件限制',
    manageSubmenu: '管理子菜单',
    hierarchyView: '层级视图',
    timeAxisView: '时间轴视图',
    moduleSubmenuInfo1: '可拖动调整子菜单的显示位置',
    moduleSubmenuInfo2:
      '选择一个选项类型的字段，数据将按照此字段中的选项值分组显示在看板中。支持组件：下拉选项（单选）、复选框（单选）',
    moduleSubmenuInfo3:
      '选择一个关联关系的字段，数据将按照此字段中的父子级从左往右按树形状进行层级显示。支持组件：关联关系（关联自己模块，如客户模块关联客户模块）',
    moduleSubmenuInfo4: '数据内容以添加的时间顺序展示',
    viewName: '视图名称',
    timelineField: '时间轴字段',
    sortOrder: '排序方式',
    selectGroupField: '选择分组字段',
    formNotEligibleField: '当前表单中没有符合条件的字段',
    fieldsGroup: '字段分组',
    cardAppearance: '卡片外观',
    moreAdd8Field: '限制添加8个字段',
    showFieldName: '显示字段名称',
    showField: '显示字段',
    pleaseSelectGroupField: '请选择分组字段',
    onlyOneSelectField: '请至少选择一个显示字段',
    startString: '起始字符',
    kanban: '看板',
    hierarchy: '层级',
    timeLine: '时间轴',
    allDynamic: '所有动态',
    onlyDynamic: '仅评论',
    onlyViewStatus: '仅查看状态',
    onlyOperationLog: '仅操作日志',
    showOlder: '显示较早的',
    groupFieldDel: '分组字段被删除，请编辑该子菜单',
    notSpecified: '未指定',
    adaptToScreen: '适应屏幕',
    unknownTime: '未知时间',
    addDataToSeas: '通过该链接可自动将数据建立到公海池中且标识不同数据提交来源',
    cashier: '收银台',
    paymentCompleted: '支付完成',
    choosePaymentMethod: '选择支付方式',
    successfulCollection: '收款成功',
    paymentByCanning: '扫一扫付款（元）',
    openMobileWechat: '打开手机微信',
    openMobileAlipay: '打开手机支付宝',
    scanToCompletePayment: '扫一扫完成支付',
    manageApplication: '应用管理',
    applicationDescription: '应用说明',
    enterpriseInfo: '企业信息',
    riskInfo: '风险信息',
    transferOtherrelatedModules: '转移其它相关模块',
    uploadMore10Files: '每次最多上传10个文件',
    onlyNewCreate: '仅新建',
    companyInfo1: '友情提示：请输入正确的名称',
    companyInfo2: '正在查询中',
    companyInfo3: '法人',
    companyInfo4: '经营状态',
    notSetAppInfo: '未设置应用说明',
    paid: '已付款',
    toBePaid: '待付款',
    orderPayment: '订单支付',
    autoCount: '自动计算',
    payCallbackInfo: '金额>0 时可点击进行收款',
    detailData: '详情资料',

    // 2020-12-25国际化
    shareOtherModule: '共享其它相关模块',
    subformBatchupdateMsg1: '对子表单的数据进行批量修改，不支持对查重字段批量修改',
    subformBatchupdateMsg2:
      '附件、图片、简单公式、函数公式、高级公式、引用公式、自动编号、流水号、条码、手写签名、简历解析',
    CopyLine: '复制行',
    OnlineConsulting: '在线咨询',
    NameFfTrialCompany: '试用机构名称',

    // 2021-04-12
    selectOneColumn: '请至少选择一个字段作为导出列',
    selectExportFields: '选择需要导出的字段（勾选代表导出该字段值）',
    companyDataKanban: '机构营销数据看板',
    personalDataKanban: '个人营销数据看板',
    visitorsToAnalysis: '访客分析',
    newAddSevendays: '近七日新增访问',
    accessTotalNum: '访问总数',
    NewDayAdd: '日新增',
    shareTotalNum: '分享总数',
    accessData: '访问数据',
    AllTotal: '累计总量',
    yesterday: '昨日',
    nearly7days: '近7天',
    nearly30days: '近30天',
    visitorsInterested: '访客兴趣',
    visitorActivity: '访客活跃度',
    VisitorProduct: '访客产品互动',
    AccessToheTotal: '访问总量',
    BusinessCardLook: '名片查看',
    BusinessCardShare: '名片分享',
    BusinessCardCollection: '名片收藏',
    productLook: '产品查看',
    productShare: '产品分享',
    product: '产品',
    videos: '视频',
    shareBusinessCard: '分享名片',
    AccessToInterest: '访问兴趣',
    AccessToSource: '访问来源',
    InteractiveRecord: '互动记录',
    AIAnalysis: 'AI分析',
    allTheRecords: '所有记录',
    transToBussData: '转为业务数据',
    sureTransBussData: '确定要转为业务数据吗?',
    batchDownload: '全部下载',

    // 2022-04-12
    InsertRowsAbove: '在上方插入行',
    InsertRowsBelow: '在下方插入行',
    DataSharingSettings: '数据共享设置',
    MapMode: '地图式',
    selectPagesExportNum: '请选择导出的分页数量',
    amount: '数量',
    relatedContent: '关联内容',
    searchModule: '搜索模块',
    largeAmountData: '数据量过大',
    largeAmountDataInfo: '请在列字段中“筛选”数据，筛选后显示列表数据'
  }
}
